// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-1-1!assets/style/video.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".showpic[data-v-5347d21c]{font-size:0;position:fixed;top:0;width:100%;height:100%;left:0;background:#243648;z-index:998;text-align:center}.showpic span[data-v-5347d21c]{height:100%}.showpic img[data-v-5347d21c],.showpic span[data-v-5347d21c]{display:inline-block;vertical-align:middle}.showpic img[data-v-5347d21c]{max-height:100%;z-index:999;max-width:100%}.top_bar[data-v-5347d21c]{z-index:999}", ""]);
// Exports
module.exports = exports;
